import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "category-label"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "category-label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.$attrs.typeshowflag > 0 && _ctx.$attrs.typelist.length > 0 ? (_openBlock(), _createElementBlock("ul", {
    key: 0,
    class: _normalizeClass(["category-ul", `fid${_ctx.$route.query.fid}`]),
    style: _normalizeStyle(_ctx.$attrs.posstyle)
  }, [_withDirectives(_createElementVNode("li", {
    class: _normalizeClass(["category-item", {
      active: $data.typeIndex === 0
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $options.typeClick(null, 0))
  }, [_createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$attrs.typeallname || "全部"), 1)], 2), [[_vShow, _ctx.$attrs.showtypeall]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.typelist, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      class: _normalizeClass(["category-item", {
        active: $data.typeIndex === index + 1
      }]),
      onClick: $event => $options.typeClick(item, index + 1)
    }, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.itemformdata.title), 1)], 10, _hoisted_2);
  }), 128))], 6)) : _createCommentVNode("", true);
}